// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_customers_ui_styles" + "." + "a738c213" + ".chunk.css";
};